import { useEffect } from "react";

import useSystemStore from "@store/useSystemStore";

export function useTheme() {
  const { isDarkMode } = useSystemStore();

  useEffect(() => {
    const bodyClass = window.document.body.classList;

    // remove both first
    bodyClass.remove("dark", "light");

    // add the correct one
    bodyClass.add(isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  return { isDarkMode };
}
